import { Alternative as r } from "./alternative.js";
import { CircleSmallFill as m } from "./circle-small-fill.js";
import { Circle as o } from "./circle.js";
import { CircleSmall as i } from "./circle-small.js";
import { CircleFill as l } from "./circle-fill.js";
import { Diversity as t } from "./diversity.js";
import { Dot as e } from "./dot.js";
import { Square as p } from "./square.js";
import { SquareFill as f } from "./square-fill.js";
import { SquareSmall as a } from "./square-small.js";
import { SquareSmallFill as S } from "./square-small-fill.js";
import { Triangle as c } from "./triangle.js";
import { TriangleFill as F } from "./triangle-fill.js";
const b = {
  Alternative: r,
  CircleSmallFill: m,
  Circle: o,
  CircleSmall: i,
  CircleFill: l,
  Diversity: t,
  Dot: e,
  Square: p,
  SquareFill: f,
  SquareSmall: a,
  SquareSmallFill: S,
  Triangle: c,
  TriangleFill: F
};
export {
  b as Shapes
};
